<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/20_20/info_g800">
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 13.5899 6.41015 16.5 10 16.5ZM10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5ZM9.5 7C9.5 6.72386 9.72386 6.5 10 6.5C10.2761 6.5 10.5 6.72386 10.5 7V11C10.5 11.2761 10.2761 11.5 10 11.5C9.72386 11.5 9.5 11.2761 9.5 11V7ZM10 12.5C9.72386 12.5 9.5 12.7239 9.5 13C9.5 13.2761 9.72386 13.5 10 13.5C10.2761 13.5 10.5 13.2761 10.5 13C10.5 12.7239 10.2761 12.5 10 12.5Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 20,
      },
      height: {
        type: [Number, String],
        default: 20,
      },
      color: {
        type: String,
        default: 'currentColor',
      },
    },

    computed: {
      viewBox() {
        return `0 0 ${this.width} ${this.height}`
      },
    },
  }
</script>
